import * as o from "react";
import { createTable as u } from "../../../table-core/build/lib/index.js";
import { ColumnFaceting as S, ColumnFiltering as R, ColumnGrouping as b, ColumnOrdering as y, ColumnPinning as w, ColumnSizing as F, ColumnVisibility as h, GlobalFaceting as O, GlobalFiltering as x, Headers as v, RowExpanding as E, RowPagination as G, RowPinning as P, RowSelection as $, RowSorting as A, _getVisibleLeafColumns as V, aggregationFns as j, buildHeaderGroups as k, createCell as z, createColumn as H, createRow as M, defaultColumnSizing as N, filterFns as T, flattenBy as U, functionalUpdate as _, getCoreRowModel as B, getMemoOptions as L, isFunction as q, isNumberArray as D, isRowSelected as I, isSubRowSelected as J, makeStateUpdater as K, memo as Q, orderColumns as W, passiveEventSupported as X, reSplitAlphaNumeric as Y, selectRowsFn as Z, shouldAutoRemoveFilter as ee, sortingFns as te } from "../../../table-core/build/lib/index.js";
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function m(e, t) {
  return e ? s(e) ? /* @__PURE__ */ o.createElement(e, t) : e : null;
}
function s(e) {
  return c(e) || typeof e == "function" || f(e);
}
function c(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function f(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function p(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = o.useState(() => ({
    current: u(t)
  })), [i, a] = o.useState(() => n.current.initialState);
  return n.current.setOptions((l) => ({
    ...l,
    ...e,
    state: {
      ...i,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (r) => {
      a(r), e.onStateChange == null || e.onStateChange(r);
    }
  })), n.current;
}
export {
  S as ColumnFaceting,
  R as ColumnFiltering,
  b as ColumnGrouping,
  y as ColumnOrdering,
  w as ColumnPinning,
  F as ColumnSizing,
  h as ColumnVisibility,
  O as GlobalFaceting,
  x as GlobalFiltering,
  v as Headers,
  E as RowExpanding,
  G as RowPagination,
  P as RowPinning,
  $ as RowSelection,
  A as RowSorting,
  V as _getVisibleLeafColumns,
  j as aggregationFns,
  k as buildHeaderGroups,
  z as createCell,
  H as createColumn,
  M as createRow,
  u as createTable,
  N as defaultColumnSizing,
  T as filterFns,
  U as flattenBy,
  m as flexRender,
  _ as functionalUpdate,
  B as getCoreRowModel,
  L as getMemoOptions,
  q as isFunction,
  D as isNumberArray,
  I as isRowSelected,
  J as isSubRowSelected,
  K as makeStateUpdater,
  Q as memo,
  W as orderColumns,
  X as passiveEventSupported,
  Y as reSplitAlphaNumeric,
  Z as selectRowsFn,
  ee as shouldAutoRemoveFilter,
  te as sortingFns,
  p as useReactTable
};
//# sourceMappingURL=index.js.map
